import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { InputGroup, Form, Button } from 'react-bootstrap'
import { applyPromoOnTicket } from '../../redux/actions/promoCodeAction'
import { errorMessage } from '../../constants/errorMessage'
import qrcode from '../../assets/img/qr-code.png'
import ScanPromoQr from './ScanPromoQr'
import { Circles } from 'react-loader-spinner'
import {
    isValidPromoCode,
    loggedInUserData
} from '../../utils/helper'
import { ticketValidation } from '../../redux/actions/ticketValidationAction'
import { useNavigate, useParams } from 'react-router-dom'
import { addEventLog } from '../../redux/actions/EventsLog'
import { getConfigDetails } from '../../services/config'
import { getTicketDetails } from '../../redux/actions/userDetails'
import CONSTANTS from '../../redux/constants'

function PromoCode(props) {
    const { dispatch, setErrorMessageLocal, length, notify, setTicketDetails, screen, ticketDetails, setDefaultPromoCode, defaultPromoCode, setPageLoad, pageLoad } = props
    const [promoCode, setPromoCode] = useState(ticketDetails?.promocode ? ticketDetails?.promocode : '')
    const [isPromoCodeAppiled, setIsPromoCodeApplied] = useState(false)
    const [hidePromocode, setHidePromocode] = useState(false)
    const [disablePromo, setDisablePromo] = useState(false)
    const [scanResult, setScanResult] = useState(null)
    const [isScanDisplay, setIsScanDisplay] = useState(false)
    const [message, setMessage] = useState('')
    const [isError, setIsError] = useState(false)
    const [isApplyValidateCode, setIsApplyValidateCode] = useState(false)
    const navigate = useNavigate()
    const { partner } = useParams()


    const rateData = JSON.parse(localStorage.getItem('seletedRateBand') ? localStorage.getItem('seletedRateBand') : '{}')
    // promocode auto apply
    const promocodeForCheckoutValue = ticketDetails?.promocode_request || []
    const isSinglePromocode = (promocodeForCheckoutValue?.length == 1) ? promocodeForCheckoutValue?.[0]?.promocode : ''
    const partnerList = ['parkSfo', 'pedemo']
    const isUserFromParkSfo = partnerList.includes(partner) || false
    // params 

    const handlePromoCode = (e, callFrom) => {
        e.preventDefault()
        const { value } = e.target
        if (callFrom == 'Dropdown') {
            setPromoCode(value)
        } else {
            // console.log(isValidPromoCode(value), 'I am here')
            // setPromoCode(isValidPromoCode(value) ? value?.toUpperCase() : '')
            setPromoCode(value?.toUpperCase())

            setIsError(false)
            setMessage('')
        }
        if (value == '') {
            handleResetPromocode()
        }
    }

    useEffect(() => {
        if (scanResult) {
            setPromoCode(isValidPromoCode(scanResult) ? scanResult?.toUpperCase() : '')
        }
        if (isSinglePromocode !== '') {
            setPromoCode(isSinglePromocode)
        }
    }, [scanResult])

    useEffect(() => {
        handleResetPromocode()
    }, [length])

    // promocode auto apply
    useEffect(() => {
        if (pageLoad && ticketDetails?.promocode && ticketDetails?.promocode != '') {
            setIsPromoCodeApplied(true)
            setPromoCode(ticketDetails?.promocode)
            setMessage(`${ticketDetails?.promocode} applied`)
        } else if (ticketDetails?.promocode && ticketDetails?.promocode != '') {
            setIsPromoCodeApplied(true)
            setPromoCode(ticketDetails?.promocode)
            setMessage(`${ticketDetails?.promocode} applied`)
            handleSubmitPromoCode('', ticketDetails?.promocode)
        } else if (defaultPromoCode) {
            setPromoCode(defaultPromoCode)
            setIsPromoCodeApplied(true)
            setMessage(`${defaultPromoCode} applied`)
            handleSubmitPromoCode('', defaultPromoCode)
        } else {
            if (isSinglePromocode !== '') {
                setPromoCode(isSinglePromocode)
            }
        }
        setPageLoad(false)

    }, [])

    const handleResetPromocode = () => {
        if (isPromoCodeAppiled) {
            setIsApplyValidateCode(true)
            setPromoCode('')

            // const paymentDetails = JSON.parse(localStorage.getItem('paymentRecipt'))
            const finalPayload = {
                ticket_id: ticketDetails?.ticket_number,
                is_promocode_apply: '0',
                promocode: promoCode,
            }
            if (ticketDetails?.facility?.is_gated_facility == 1) {
                finalPayload.is_gated = 1
            } else {
                finalPayload.is_gated = 0
            }

            dispatch(applyPromoOnTicket(finalPayload)).then((res) => {
                setDefaultPromoCode('')
                setIsApplyValidateCode(false)
                if (res?.data) {
                    // const listItem = [{ 'headerName': 'Parking Amount', 'val': `$${res?.data?.base_amount}` }, { 'headerName': 'Tax', 'val': `$${res?.data?.tax_fee}` }, { 'headerName': 'Processing Fee', 'val': `$${res?.data?.processing_fee}` }]
                    if (screen && screen == 'extend') {
                        localStorage.removeItem('ExtendData')
                        localStorage.setItem('ExtendData', JSON.stringify(res?.data))
                    } else {
                        localStorage.removeItem('paymentRecipt')
                        localStorage.setItem('paymentRecipt', JSON.stringify(res?.data))
                    }
                    localStorage.setItem('isCouponApplied', false)
                    setTicketDetails(res?.data)
                    setIsPromoCodeApplied(false)
                    setIsError(false)
                    setMessage('Validation Code Removed')
                    //end
                } else {
                    setIsPromoCodeApplied(true)
                    notify('error', errorMessage?.somethingWentWrong)
                    setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsError(true)
                    setMessage(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                }
            }).catch((err) => {
                setIsApplyValidateCode(false)
                setIsPromoCodeApplied(true)
                notify('error', errorMessage?.somethingWentWrong)
                setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                setIsError(true)
                setMessage(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            })

        } else {
            setPromoCode('')
        }
    }


    useEffect(() => {
        if (isSinglePromocode !== '') {
            setPromoCode(isSinglePromocode)
        }
        if (ticketDetails?.payment_date && ticketDetails?.is_overstay == '0' && ticketDetails?.promocode) {
            // console.log('true', ticketDetails?.payment_date && ticketDetails?.is_overstay == '0' && ticketDetails?.promocode,
            // ticketDetails?.payment_date , ticketDetails?.is_overstay == '0' , ticketDetails?.promocode)
            setHidePromocode(true)

        } else if (ticketDetails?.facility?.is_gated_facility != '1' && ((ticketDetails?.reservation_id != null && ticketDetails?.reservation_id != '') || (ticketDetails?.user_pass_id != null && ticketDetails?.user_pass_id != '') || (ticketDetails?.permit_request_id != null && ticketDetails?.permit_request_id != ''))) {
            setDisablePromo(true)
            setHidePromocode(true)
        } else {
            if (isSinglePromocode !== '') {
                setTimeout(() => {
                    handleSubmitPromoCode(isSinglePromocode)
                }, 1500)
            }
        }
    }, [])

    const handleSubmitPromoCode = (customPromocode = '', defaultPromo = '') => {
        customPromocode = (isUserFromParkSfo && isSinglePromocode !== '') ? isSinglePromocode : ''
        setIsApplyValidateCode(true)
        let promo = promoCode ? promoCode : customPromocode ? customPromocode : defaultPromo ? defaultPromo : ''
        // console.log(isValidPromoCode(promo), promo, ticketDetails, 'I am here 2')
        if (((promoCode !== '' && promoCode !== null) || customPromocode !== '' || defaultPromo !== '') && ticketDetails?.paid_type == '9' && isValidPromoCode(promo)) {
            const finalPayload = {
                ticket_id: ticketDetails?.ticket_number,
                is_promocode_apply: '1',
                promocode: promoCode ? promoCode : customPromocode ? customPromocode : defaultPromo,
                'phone': ticketDetails?.user?.phone_number ? ticketDetails?.user?.phone_number : loggedInUserData()?.user?.phone ? loggedInUserData()?.user?.phone : '',
                'license_plate': ticketDetails?.license_plate ? ticketDetails?.license_plate : '',
                'email': ticketDetails?.user?.email ? ticketDetails?.user?.email : loggedInUserData()?.user?.email ? loggedInUserData()?.user?.email : ''
            }
            if (ticketDetails?.facility?.is_price_band == 1 && rateData?.id) {
                finalPayload.rate_band_id = rateData?.id
            } else {
                finalPayload.length = length
            }

            if (ticketDetails?.facility?.is_gated_facility == 1) {
                finalPayload.is_gated = 1
            } else {
                finalPayload.is_gated = 0
            }


            dispatch(applyPromoOnTicket(finalPayload)).then((res) => {
                setDefaultPromoCode('')
                setIsPromoCodeApplied(true)
                if (res?.data) {
                    // if(Number(res?.data?.payable_amount) === 0) {
                    //     setIsDirectCheckout(true)
                    // }
                    setIsApplyValidateCode(false)
                    localStorage.setItem('isCouponApplied', true)
                    setTicketDetails(res?.data)
                    setIsPromoCodeApplied(true)
                    setIsError(false)
                    // setMessage('Validation Code Applied Successfully')
                    setMessage(`${promoCode} applied`)
                    //end
                } else {
                    // notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsApplyValidateCode(false)
                    setIsPromoCodeApplied(false)
                    localStorage.setItem('isCouponApplied', false)
                    setErrorMessageLocal(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsError(true)
                    setMessage(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                }
            }).catch((err) => {
                // notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                setIsApplyValidateCode(false)
                setIsPromoCodeApplied(false)
                localStorage.setItem('isCouponApplied', false)
                setErrorMessageLocal(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                setIsError(true)
                setMessage(err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            })
        } else if (ticketDetails?.paid_type) {
            setIsApplyValidateCode(false)
            notify('error', 'The Validation discount already availed.')
        } else {
            setIsApplyValidateCode(false)
            setIsError(true)
            setMessage('Please enter a validation code')
        }

    }

    const handleQrScan = () => {
        if (!isPromoCodeAppiled && !disablePromo) {
            setIsScanDisplay(true)
        }
    }

    const apifuntocall = (qrcodeId, ticketNumber) => {
        const payload = { 'ticket_number': ticketNumber, channel: 'web', business_qrcode: qrcodeId }
        dispatch(ticketValidation(payload)).then((res) => {
            if (res?.status === 201 || res?.status === 200) {
                getUpdatedTicketDetails(ticketNumber)
                navigate(`/${partner}/ticket/${res?.data?.ticket_number || ticketNumber}`)
                notify('success', 'E-Ticket has been validated successfully.')
            } else {
                notify(
                    'error',
                    res?.errors?.message
                        ? res?.errors?.message
                        : errorMessage?.somethingWentWrong
                )
                // navigate(`/${partner}/paymentResponse`)
            }
        })
    }

    const getUpdatedTicketDetails = (ticketNumber) => {
        const payloadTicket = {
            'ticket': ticketNumber,
            'phone': '',
            'cardLast4': '',
            'cardExpiry': '',
            'license_plate': '',
            'partner_id': getConfigDetails()?.PARTNER_ID,
        }
        dispatch(getTicketDetails(payloadTicket)).then((res) => {
            if (res?.status === 201 || res?.status === 200) {
                if (res?.data && res?.data != null) {
                    setTicketDetails(res?.data)
                    // notify('success', 'T successfully')
                    localStorage?.setItem('paymentRecipt', JSON.stringify(res?.data))
                    // setRemainingAmount((Number(res?.data?.payable_amount) - Number(res?.data?.grand_total)).toFixed(2))
                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    let errObject = {
                        payload: payloadTicket,
                        error: res,
                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PromoCode.js-131`))
                }
            } else {
                // setError(res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                let errObject = {
                    payload: payloadTicket,
                    error: res,
                    errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PromoCode.js-131`))
            }
        }).catch((err) => {
            let errObject = {
                payload: payloadTicket,
                error: err,
                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getTicketDetails-PromoCode.js-131`))
            notify('error', errorMessage?.somethingWentWrong)
        })
    }


    return (
        <div><div className='mb-3 mt-3'>
            {/* <Form.Label className='text-info styleLables'>Promo Code</Form.Label> */}
            {(isUserFromParkSfo) ?
                <InputGroup className=" myiconset border rounded d-flex justify-content-center align-items-center">
                    <Form.Select aria-label="Default select example" value={(promoCode) ?? (isSinglePromocode)} disabled={(isSinglePromocode && isPromoCodeAppiled) ? true : false} onChange={(e) => handlePromoCode(e, 'Dropdown')}>
                        <option value=''>Select Promocode</option>
                        {(promocodeForCheckoutValue.length > 0) ? promocodeForCheckoutValue?.map((item, index) => <option value={item?.promocode} key={index}>{item?.promocode}</option>) : null}
                    </Form.Select>
                    {!isPromoCodeAppiled ?
                        <Button disabled={isApplyValidateCode} className='border-0' variant=" text-primary" type='button' id="button-addon2" onClick={handleSubmitPromoCode}>
                            <div className='d-flex'>
                                <span className='me-2'>Apply</span>
                                {isApplyValidateCode ? <Circles height="20" width="20" style={{ display: 'inline-block' }} color="var(--bs-primary)" ariaLabel="circles-loading" visible={true} /> : ''}
                            </div>
                        </Button>
                        : <Button variant=" text-danger" type='button' id="button-addon2" onClick={handleResetPromocode}>
                            <div className='d-flex'>
                                <i className='fa-1x fa fa-times me-2'> </i>
                                {isApplyValidateCode ? <Circles height="20" width="20" style={{ display: 'inline-block' }} color="var(--bs-primary)" ariaLabel="circles-loading" visible={true} /> : ''}
                            </div>
                        </Button>
                    }
                    <img src={qrcode} className='me-2 qr-img' alt="Scan QR for Code" onClick={() => handleQrScan()} />
                </InputGroup>
                :
                <InputGroup className=" myiconset border rounded d-flex justify-content-center align-items-center">
                    <Form.Control className='border-0' disabled={hidePromocode || isPromoCodeAppiled || disablePromo} placeholder="Validate Ticket" aria-label="PromoCode" aria-describedby="basic-addon2" value={promoCode} onChange={(e) => handlePromoCode(e, 'input')} />
                    {(!isPromoCodeAppiled && !hidePromocode) ?
                        <Button className='border-0' variant=" text-primary" type='button' id="button-addon2" onClick={handleSubmitPromoCode}>
                            <div className='d-flex'>
                                <span className='me-2'>Apply</span>
                                {isApplyValidateCode ? <Circles height="20" width="20" style={{ display: 'inline-block' }} color="var(--bs-primary)" ariaLabel="circles-loading" visible={true} /> : ''}
                            </div>
                        </Button> : (!hidePromocode && ticketDetails?.facility?.is_gated_facility == '1') ? <Button variant=" text-danger" type='button' id="button-addon2" onClick={handleResetPromocode}>
                            <div className='d-flex'>
                                <i className='fa-1x fa fa-times me-2'> </i>
                                {isApplyValidateCode ? <Circles height="20" width="20" style={{ display: 'inline-block' }} color="var(--bs-primary)" ariaLabel="circles-loading" visible={true} /> : ''}
                            </div>
                        </Button> : ''}
                    <img src={qrcode} className='me-2 qr-img' alt="Scan QR for Code" onClick={() => handleQrScan()} />
                </InputGroup>}
            <span className={isError ? 'text-danger small text-left mt-1' : 'text-success small text-left mt-1'}>{isPromoCodeAppiled ? <i className='me-1 fa fa-check-circle'></i> : ''}{message}</span>
        </div>
            {isScanDisplay && <ScanPromoQr
                setScanResult={setScanResult}
                scanResult={scanResult}
                setIsScanDisplay={setIsScanDisplay}
                handleValidateTicket={apifuntocall}
            />}
        </div>
    )

}

PromoCode.propTypes = {
    dispatch: PropTypes.func,
    facility: PropTypes.string,
    setStateList: PropTypes.func,
    setFaciltyData: PropTypes.func,
    setValue: PropTypes.func,
    setErrorMessageLocal: PropTypes.func,
    length: PropTypes.string,
    isTicketApply: PropTypes.bool,
    notify: PropTypes.func,
    setTicketDetails: PropTypes.func,
    screen: PropTypes.string,
    resetPromocode: PropTypes.bool,
    ticketDetails: PropTypes.object,
    getValues: PropTypes.func,
    setIsDirectCheckout: PropTypes.func,
    setDefaultPromoCode: PropTypes.func,
    defaultPromoCode: PropTypes.string,
    setPageLoad: PropTypes.func,
    pageLoad: PropTypes.bool,
}

PromoCode.defaulProps = {
    dispatch: noop,
    facility: '',
    setStateList: noop,
    setFaciltyData: noop,
    setValue: noop,
    setErrorMessageLocal: noop,
    length: '',
    isTicketApply: false,
    notify: noop,
    setTicketDetails: noop,
    screen: '',
    resetPromocode: false,
    PropTypes: noop,
    getValues: noop,
    setIsDirectCheckout: noop,
    setDefaultPromoCode: noop,
    defaultPromoCode: '',
    setPageLoad: noop,
    pageLoad: true
}

function mapStateToProps() {
    return {}
}
export default connect(mapStateToProps)(PromoCode)